import Reflux from "reflux";
import _ from "lodash";
import Immutable, { Map } from "immutable";
import AppConstants from "../constants/AppConstants";
import { gatherProps } from "../utils/Merge/MergeUtils.mjs";

const { BG_PROPERTY_FILL_TYPE, BG_PROPERTY_MEDIA_TYPE, LAYOUT_DESKTOP, LAYOUT_MOBILE } =
  AppConstants;

const pageInfoModel = {
  id: null,
  name: "",
  blocks: [],
};

const DesignBrowserStore = Reflux.createStore({
  storeName: 'DesignBrowserStore',
  init() {
    this.design = null;
    this.page = null;

    this.pageMobileBG = null;
    this.pageDesktopBG = null;

    this.designInfo = {
      id: null,
      name: "",
      pages: [],
      wppages: [],
      blocks: [],
    };

    this.pageInfo = {
      id: null,
      name: "",
      blocks: [],
    };
  },

  setDesign(design) {
    this.design = design;
    this.designInfo.id = _.get(design, "id");
    this.designInfo.name = _.get(design, "name");

    this._updatePageList();
    this.designInfo.blocks = this._getBlockList(this.design);

    this.page = null;
    this.pageInfo = _.cloneDeep(pageInfoModel);

    this.pageMobileBG = null;
    this.pageDesktopBG = null;
  },

  setPage(page) {
    this.page = page;
    this.pageInfo.id = _.get(page, "id");
    this.pageInfo.name = _.get(page, "name");

    this.pageInfo.blocks = this._getBlockList(this.page);

    const { desktop = {}, mobile = {}, sync = [] } = this.page;
    const pageMap = Map({
      desktop: Map(desktop),
      mobile: Map(mobile),
      sync,
    });

    const mobileBG = gatherProps(
      pageMap,
      LAYOUT_MOBILE,
      [BG_PROPERTY_FILL_TYPE, BG_PROPERTY_MEDIA_TYPE],
      true
    );
    const desktopBG = gatherProps(
      pageMap,
      LAYOUT_DESKTOP,
      [BG_PROPERTY_FILL_TYPE, BG_PROPERTY_MEDIA_TYPE],
      true
    );

    if (mobileBG) {
      this.pageMobileBG = Immutable.fromJS(mobileBG);
    }

    if (desktopBG) {
      this.pageDesktopBG = Immutable.fromJS(desktopBG);
    }
  },

  _updatePageList() {
    var pageOrder = _.get(this.design, "pages");
    var items = _.get(this.design, "items");

    var pages = [];
    var wppages = [];

    let page = null;
    pageOrder.forEach(function (pageId) {
      page = _.get(items, pageId, false);
      if (page) {
        _.has(page, "wp") ? wppages.push(page) : pages.push(page);
      }
    });

    this.designInfo.pages = pages;
    this.designInfo.wppages = wppages;
  },

  _getBlockList(container) {
    var blockOrder = _.get(container, "blocks");
    var blocks = [];

    if (_.size(blockOrder) > 0) {
      var blockData = _.get(container, "blockData");

      let block = null;
      blockOrder.forEach(function (blockId) {
        block = _.get(blockData, blockId, false);
        if (block) {
          blocks.push(block);
        }
      });
    }

    return blocks;
  },

  _generatePreview(selection) {
    var blocks = [];
    var setBG = true;

    switch (selection.type) {
      case AppConstants.DESIGN_TYPE_SITE_BLOCK:
        var block = _.get(this.design, ["blockData", selection.id]);
        if (block != null) {
          blocks.push(block);
        }
        setBG = false;
        break;
      case AppConstants.DESIGN_TYPE_PAGE:
        var pageBlocks = _.get(this.page, "blocks", []);

        _.map(
          pageBlocks,
          _.bind(function (blockId) {
            var block = _.get(this.page, ["blockData", blockId]);
            if (block) {
              block = this._setSiteBlock(block);
              blocks.push(block);
            }
          }, this)
        );

        break;
      case AppConstants.DESIGN_TYPE_BLOCK:
        var block = _.get(this.page, ["blockData", selection.id]);
        if (block != null) {
          block = this._setSiteBlock(block);
          blocks.push(block);
        }
        break;
    }

    const blockList = Immutable.fromJS(blocks);
    const theme = Immutable.fromJS(_.get(this.design, "theme"));
    const config = Immutable.fromJS(_.get(this.design, "config"));

    var info = {
      config,
      theme,
      blocks: blockList,
    };

    if (setBG) {
      info.backgrounds = {};
      info.backgrounds[AppConstants.LAYOUT_MOBILE] = this.pageMobileBG;
      info.backgrounds[AppConstants.LAYOUT_DESKTOP] = this.pageDesktopBG;
    }

    return info;
  },

  _setSiteBlock(block) {
    if (_.has(block, AppConstants.BLOCK_PROP_PARENT_BLOCK_ID)) {
      var siteBlock = _.get(this.design, [
        "blockData",
        _.get(block, AppConstants.BLOCK_PROP_PARENT_BLOCK_ID),
      ]);
      if (siteBlock) {
        _.set(block, AppConstants.BLOCK_PROP_PARENT_BLOCK, siteBlock);
      }
    }

    return block;
  },

  getDesignInfo() {
    return this.designInfo;
  },

  getPageInfo() {
    return this.pageInfo;
  },

  getDesignItemPreviewData(selection) {
    return this._generatePreview(selection);
  },

  getDesignItemData(selection) {
    const data = {
      designId: this.designInfo.id,
      type: selection.type,
      item: null,
      theme: _.get(this.design, "theme"),
    };

    switch (selection.type) {
      case AppConstants.DESIGN_TYPE_SITE_BLOCK:
        var siteBlock = _.get(this.design, ["blockData", selection.id]);
        if (siteBlock) {
          data.item = siteBlock;
        }
        break;
      case AppConstants.DESIGN_TYPE_PAGE:
        if (this.page != null) {
          data.item = this.page;
        }

        break;
      case AppConstants.DESIGN_TYPE_BLOCK:
        var block = _.get(this.page, ["blockData", selection.id]);
        if (block) {
          data.item = block;
        }
        break;
      default:
    }

    return data;
  },
});

export default DesignBrowserStore;
